// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BlogSearch_wrapper__YjQDI","count":"BlogSearch_count__9IhmT","notFound":"BlogSearch_notFound__ZhBXb","notFoundContent":"BlogSearch_notFoundContent__nsBa2"};